import { render, staticRenderFns } from "./SpecificExtraWorkManagementListWeb.vue?vue&type=template&id=33dce9b2&"
import script from "./SpecificExtraWorkManagementListWeb.vue?vue&type=script&lang=js&"
export * from "./SpecificExtraWorkManagementListWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VDataTable})
